module.exports = __webpack_public_path__ + "img/banner_tab1.a2ea3a33.png";